import Footer from "../Footer";
import HeroSection from "../HeroSection";
import MySkills from "../MySkills";
import MyProjects from "../MyProjects";
import MyEdEx from "../MyEdEx";
import MyAchEx from "../MyAchEx";
import MyCert from "../MyCert";

export default function Home() {
  return (
    <>
      <HeroSection />
      <MyEdEx />
      <MyProjects />
      <MySkills />
      <MyAchEx />
      <MyCert />
      <Footer />
    </>
  );
}
